/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * jump_clone object
 * @export
 * @interface GetCharactersCharacterIdClonesJumpClone
 */
export interface GetCharactersCharacterIdClonesJumpClone {
    /**
     * implants array
     * @type {Array<number>}
     * @memberof GetCharactersCharacterIdClonesJumpClone
     */
    implants: Array<number>;
    /**
     * jump_clone_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdClonesJumpClone
     */
    jumpCloneId: number;
    /**
     * location_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdClonesJumpClone
     */
    locationId: number;
    /**
     * location_type string
     * @type {string}
     * @memberof GetCharactersCharacterIdClonesJumpClone
     */
    locationType: GetCharactersCharacterIdClonesJumpCloneLocationTypeEnum;
    /**
     * name string
     * @type {string}
     * @memberof GetCharactersCharacterIdClonesJumpClone
     */
    name?: string;
}


/**
 * @export
 */
export const GetCharactersCharacterIdClonesJumpCloneLocationTypeEnum = {
    Station: 'station',
    Structure: 'structure'
} as const;
export type GetCharactersCharacterIdClonesJumpCloneLocationTypeEnum = typeof GetCharactersCharacterIdClonesJumpCloneLocationTypeEnum[keyof typeof GetCharactersCharacterIdClonesJumpCloneLocationTypeEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdClonesJumpClone interface.
 */
export function instanceOfGetCharactersCharacterIdClonesJumpClone(value: object): value is GetCharactersCharacterIdClonesJumpClone {
    if (!('implants' in value) || value['implants'] === undefined) return false;
    if (!('jumpCloneId' in value) || value['jumpCloneId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationType' in value) || value['locationType'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdClonesJumpCloneFromJSON(json: any): GetCharactersCharacterIdClonesJumpClone {
    return GetCharactersCharacterIdClonesJumpCloneFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesJumpCloneFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdClonesJumpClone {
    if (json == null) {
        return json;
    }
    return {
        
        'implants': json['implants'],
        'jumpCloneId': json['jump_clone_id'],
        'locationId': json['location_id'],
        'locationType': json['location_type'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetCharactersCharacterIdClonesJumpCloneToJSON(json: any): GetCharactersCharacterIdClonesJumpClone {
    return GetCharactersCharacterIdClonesJumpCloneToJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesJumpCloneToJSONTyped(value?: GetCharactersCharacterIdClonesJumpClone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'implants': value['implants'],
        'jump_clone_id': value['jumpCloneId'],
        'location_id': value['locationId'],
        'location_type': value['locationType'],
        'name': value['name'],
    };
}

